import { PdaAccessToken } from "src/app/pda/utils/Service/pda-auth.service";

export class PdaDownloadRicevutaRequest{
  token!: PdaAccessToken;
  codiceCRS!: string;
  copiaOriginale!: boolean;
  idPagamento!: string;
  bollo!: boolean;
  tipo!: string;
};
